var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmailBlue = function SvgEmailBlue(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1818 0.75H1.8182C1.21571 0.75 0.727295 1.25368 0.727295 1.875V10.125C0.727295 10.7463 1.21571 11.25 1.8182 11.25H14.1818C14.7843 11.25 15.2727 10.7463 15.2727 10.125V1.875C15.2727 1.25368 14.7843 0.75 14.1818 0.75Z",
    stroke: "#0258FF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 7.875L1.66319 3.95344C1.14631 3.63357 0.727295 2.87046 0.727295 2.25245V1.87383C0.727295 1.25315 1.21577 0.75 1.8161 0.75H14.1839C14.7843 0.75 15.2727 1.25315 15.2727 1.87383V2.25245C15.2727 2.87201 14.8556 3.6324 14.3369 3.95344L8.00002 7.875Z",
    stroke: "#0258FF",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/email-blue.907354dd.svg";
export { ForwardRef as ReactComponent };